import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as common from '../../../../../common'
import type { Expression } from '../../expression'
import type * as expressionNode from '../../node'
import type { FnHelper } from '../helper'
import { Key } from '../key'
import * as fnNode from '../node'

import {
  CommonArgs,
  removeIsolatedValueNodes,
  standardNodeCreator,
} from './utils'

/**
 * TODO ({ key: string; value: any }[] -> object)
 *
 * @param todo TODO
 * @example
 * TODO
 * // ->
 * TODO
 */
export interface GreaterThan<out T = any> {
  /** {@link GreaterThan} */
  readonly [Key.GreaterThan]: T extends boolean
    ? readonly Expression<any>[]
    : never
}
export namespace GreaterThan {
  export const isGreaterThan: TypeChecker<GreaterThan> =
    TypeChecker.Factory.lazy(() =>
      TypeChecker.Factory.object<GreaterThan>({
        [Key.GreaterThan]: CommonArgs.isListOfExpressions,
      }),
    ).usingAlias('Fn.GreaterThan')
  export const assertIsGreaterThan: TypeAsserter<GreaterThan> =
    TypeAsserter.Factory.from(isGreaterThan)

  /**
   * @see {@link Node}
   */
  export class Node<T extends boolean = boolean> extends fnNode.Node<
    T,
    Key.GreaterThan,
    readonly expressionNode.Node[]
  > {
    public readonly type = common.value.types.Intrinsic.Boolean

    constructor(arg: Node<T>['arg']) {
      super(Key.GreaterThan, arg)
    }
  }
  export namespace Node {
    export const isNode: TypeChecker<Node> = TypeChecker.Factory.instance(Node)
    export const assertIsNode: TypeAsserter<Node> =
      TypeAsserter.Factory.from(isNode)
  }

  const expressionsInArgs: FnHelper<GreaterThan>['expressionsInArgs'] = fn =>
    fn[Key.GreaterThan]
  export const HELPER: FnHelper<GreaterThan> = {
    createNode: standardNodeCreator.comparison({
      compare: (a, b) => a > b,
      getArgExpressions: expressionsInArgs,
      nodeClass: Node,
    }),
    expressionsInArgs,
    typeChecker: isGreaterThan,
  }
}
